// extracted by mini-css-extract-plugin
export default {"container":"SelectInput_container__0sGVj","label":"SelectInput_label__Nact2","select":"SelectInput_select__BYfMo"};